import { normalizeAudienceMode } from "./audienceMode";
import { normalizeAwsRegion, type AwsRegionId } from "./awsRegion";
import { normalizeComputeProfile } from "./computeProfile";
import { applyWorkloadOverrides, estimateMonthlyCost } from "./costEngine";
import { normalizeDeploymentStack } from "./deploymentStack";
import { normalizeLlmPriceProfile, type LlmPriceProfile } from "./llmPriceProfile";
import type { PersistedUi } from "./persistedUi";
import { normalizeSavingsLevers } from "./savingsLevers";
import { coerceWorkload } from "./workloadState";
import type { Locale } from "../i18n/locale";
import type { CostEstimate } from "./types";

/** Оцінка з знімка PersistedUi (для preview / пакетного експорту). */
export function estimateFromPersistedSnapshot(
  state: PersistedUi,
  locale: Locale,
): CostEstimate | null {
  const w = state.workload ? coerceWorkload(state.workload) : null;
  if (!w) return null;
  const base = applyWorkloadOverrides(w, {
    usersDaily: Math.round(w.usersDaily * state.userMult),
    requestsPerUser: Math.round(w.requestsPerUser * state.reqMult),
  });
  const region: AwsRegionId = normalizeAwsRegion(state.awsRegion);
  const savings = normalizeSavingsLevers(state.savings);
  const stack = normalizeDeploymentStack(state.deploymentStack, state.addonInfra);
  const llm: LlmPriceProfile = normalizeLlmPriceProfile(state.llmPriceProfile);
  const audience = normalizeAudienceMode(state.audienceMode);
  const computeProfile = normalizeComputeProfile(state.computeProfile);
  return estimateMonthlyCost(
    base,
    locale,
    region,
    savings,
    stack,
    llm,
    audience,
    computeProfile,
  );
}
